<div class="page-header-back">
  <a (click)="showMenu()">
    <span class="valio-icon icon-inline icon-chevron icon-chevron-left margin-right-sm d-md-none"></span>
  </a>
</div>
<div class="page-header-title">
  <h1>{{'myaccount.title'|cxTranslate}}</h1>
</div>
